import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ReportItem } from '../../services/model';

export interface DialogData {
  reportItem: ReportItem;
}

@Component({
  selector: 'app-note-edit-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './note-edit-dialog.component.html',
  styleUrl: './note-edit-dialog.component.scss',
})
export class NoteEditDialogComponent {
  reportItem: ReportItem;
  description: string;

  noteSic: string = '';

  constructor(
    public dialogRef: MatDialogRef<NoteEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.reportItem = data.reportItem;
    this.description = data.reportItem.note;
    this.noteSic = data.reportItem.customNote;
  }

  revertInput() {
    this.reportItem.customNote = this.noteSic;
  }
}
